const noResults = (pageData) => {
  return {
    title: pageData.noResultsFormTitle || "Let’s start a conversation",
    text:
      pageData.noResultsFormText ||
      "It seems that we couldn’t find any spaces that match your search criteria but don’t worry, get in touch with us and a Workplace One representative will reach out to help you find the right space for your team.",
    formSubmissionTitle: "No Results",
  }
}

const teamSuites = (pageData) => {
  return {
    title:
      pageData.teamSuitesFormTitle ||
      "Let’s start a conversation about Office Suites",
    text:
      pageData.teamSuitesFormText ||
      "Large, fully-furnished turnkey office suites that are home to private meeting rooms, common areas and office space.",
    formSubmissionTitle: "Office Suites",
  }
}

const hqs = (pageData) => {
  return {
    title:
      pageData.hqSuitesFormTitle ||
      "Let’s start a conversation about HQ Suites",
    text:
      pageData.hqSuitesFormText ||
      "Fully customized office space on a private floor with your own entrance, branding, meeting rooms, phone booths, and amenities.",
    formSubmissionTitle: "HQ Suites",
  }
}

const managers = {
  Toronto: {
    name: "Lauren Tapp",
    title: "VP, Leasing and Marketing",
    image: require("../../images/lauren-tapp.png").default,
    email: "",
  },
  Kitchener: {
    name: "Andrea Hennige",
    title: "Community Manager",
    image: require("../../images/andrea-hennige.jpg").default,
    email: "",
  },
}

export { noResults, teamSuites, hqs, managers }
